import React from "react";

export const CommentComponentStyles: React.CSSProperties = {
  resize: "vertical",
  fontSize: 11,
  lineHeight: "14px",
  height: "67px",
};

export default CommentComponentStyles;
